import { render, staticRenderFns } from "./Solucoes.vue?vue&type=template&id=d21bdb16&scoped=true&"
import script from "./Solucoes.vue?vue&type=script&lang=js&"
export * from "./Solucoes.vue?vue&type=script&lang=js&"
import style0 from "./Solucoes.vue?vue&type=style&index=0&id=d21bdb16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d21bdb16",
  null
  
)

export default component.exports